import { useMemo } from 'react'
import { Node } from 'reactflow'
import { BerthWithActions } from '../models/yard-view.model'
import { BerthViewStore } from '../stores/nodes/berth.view-store'
import { YardViewStore } from '../stores/yard.view-store'

const FOCUSED_Z_INDEX = 1000

export const useBerthNodes = (
  viewStore: YardViewStore,
  berthViewStore: BerthViewStore,
): Node<BerthWithActions>[] =>
  useMemo<Node<BerthWithActions>[]>(
    () =>
      viewStore.berths.map(berth => ({
        id: berth.id,
        type: 'berth',
        ...(viewStore.focusedBerthId === berth.id && { zIndex: FOCUSED_Z_INDEX }),
        position: {
          x: berth.layoutPosition.x,
          y: berth.layoutPosition.y,
        },
        data: {
          ...berth,
          isEditable: !viewStore.isViewMode,
          showNodeHeaders: viewStore.showNodeHeaders,
          focused: viewStore.focusedBerthId === berth.id,
          onEdit: berthViewStore.openFormDialog,
          onFocus: viewStore.setFocusedBerthId,
          onDelete: berthViewStore.setDeleteDialogOpen,
          onRotate: berthViewStore.setRotation,
        },
      })),
    [
      viewStore.berths,
      viewStore.focusedBerthId,
      viewStore.isViewMode,
      viewStore.showNodeHeaders,
      viewStore.setFocusedBerthId,
      berthViewStore,
    ],
  )
